import React from 'react';

import { ShieldLockIcon } from '@primer/octicons-react';
import { StyledOcticon } from '@primer/react';

import classNames from 'classnames';
import isString from 'lodash/isString';

import Label from '../common/Labels/Label';
import LoadingSpinner from '../common/LoadingSpinner/LoadingSpinner';

const AuthenticationGraphic = () => (
  <StyledOcticon
    className="text-brand"
    icon={ShieldLockIcon}
    size={64}
  />
)

export const AuthenticationSlate = ({
  className = 'p-4',
  mainText = 'Authenticating',
  subText = 'Please give us a moment to check your information...',
}) => (
  <div className={classNames('flex flex-col items-center justify-start', className)}>
    <AuthenticationGraphic />
    {
      isString(mainText) ? (
        <div className="my-4 flex flex-row justify-center">
          <Label color="gray-600" size="2xl" bold>
            {mainText}
          </Label>
          <LoadingSpinner className="ml-2" animationKey="app-auth-loading-spinner" />
        </div>
      ) : null
    }
    {
      isString(subText) ? (
        <Label className="my-4" color="gray-600" size="xl">
          {subText}
        </Label>
      ) : null
    }
  </div>
)

export default AuthenticationSlate;
